﻿import { OpaccBasketInfo } from './vendor/script/classes/opacc.class.basket-info.js';
import { OpaccBasketShipping  } from './vendor/script/classes/opacc.class.basket-shipping.js';
import { OpaccBasketQuickOrder  } from './vendor/script/classes/opacc.class.basket-quickorder.js';
import { OpaccBasketPayment  } from './vendor/script/classes/opacc.class.basket-payment.js';
import CustomOpaccBasketAction from './te.basket.btn.helper.js';

export const opaccBasketInfoPlugin = new OpaccBasketInfo();
export const opaccBasketActionPlugin = new CustomOpaccBasketAction();
export const opaccBasketPaymentPlugin = new OpaccBasketPayment();
export const opaccBasketShippingPlugin = new OpaccBasketShipping();
export const opaccBasketQuickOrderPlugin = new OpaccBasketQuickOrder();

